import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Tabs,
  Tab,
  Typography,
  Button,
  IconButton,
  useMediaQuery,
  useTheme,
  Divider,
  Card,
} from "@mui/material";
const CompensationDetails = () => {
    return (
        <Box sx={{ py: 2 }}>
            <Typography variant="h6" color="primary" gutterBottom>Compensation Details</Typography>
            <Typography variant="body2" color="text.secondary">
                Yaha salary breakups, CTC structures, allowances, aur structure metrics dashboard render hoga.
            </Typography>
        </Box>
    )
}

export default CompensationDetails
